import "../config/cssDTB/buttonsDTB.css";
const $ = require("jquery");
$.Datatable = require("datatables.net");
require("datatables.net-buttons")(window, $);
require("datatables.net-buttons/js/buttons.html5.js")();
window.JSZip = require("jszip");

function ConfDtb() {
  $("#autonum").DataTable({
    paging: false,
    searching: false,
    info: false,
    ordering: false,
    orderable: false,
    columnDefs: [
      {
        targets: 0,
        data: null,
        ordering: false,
        orderable: false,
        render: function (data, type, row, meta) {
          return meta.row + 1;
        },
      },
    ],
  });

  $("#searchTable").DataTable({
    paging: false,
    ordering: true,
    info: false,
    order: [[1, "asc"]],
    language: {
      sSearch: "Cari : ",
    },
  });

  $(".searchTable").DataTable({
    paging: false,
    ordering: false,
    info: false,
    language: {
      sSearch: "Cari : ",
    },
  });

  var tableNumberSearch = $("#tableNumberSearch").DataTable({
    paging: false,
    ordering: false,
    info: false,
    language: {
      sSearch: "Cari : ",
    },
  });

  tableNumberSearch
    .on("order.dt search.dt", function () {
      tableNumberSearch
        .column(0, { search: "applied", order: "applied" })
        .nodes()
        .each(function (cell, i) {
          cell.innerHTML = `${i + 1}`;
        });
    })
    .draw();

  $("#tabel").DataTable({
    order: [[0, "asc"]],
    paging: true,
    ordering: true,
    info: true,
    filter: true,
    pageLength: 10,
    retrieve: true,
    language: {
      sEmptyTable: "Tidak Ada Data",
      sProcessing: "Sedang memproses...",
      sLengthMenu: "tampil : _MENU_",
      sZeroRecords: "Tidak ditemukan data yang sesuai",
      sInfo: "_END_ dari total _TOTAL_ data",
      sInfoEmpty: "0 data",
      sInfoFiltered: "(disaring dari _MAX_ data)",
      sInfoPostFix: "",
      sSearch: "Cari : ",
      sUrl: "",
      oPaginate: {
        sFirst: "Pertama",
        sPrevious: "&laquo;",
        sNext: "&raquo;",
        sLast: "Terakhir",
      },
    },
  });

  $("#jadwalreguler").DataTable({
    order: [[0, "asc"]],
    paging: true,
    ordering: true,
    info: true,
    filter: true,
    pageLength: 10,
    retrieve: true,
    language: {
      sEmptyTable: "Tidak Ada Data",
      sProcessing: "Sedang memproses...",
      sLengthMenu: "tampil : _MENU_",
      sZeroRecords: "Tidak ditemukan data yang sesuai",
      sInfo: "_END_ dari total _TOTAL_ data",
      sInfoEmpty: "0 data",
      sInfoFiltered: "(disaring dari _MAX_ data)",
      sInfoPostFix: "",
      sSearch: "Cari : ",
      sUrl: "",
      oPaginate: {
        sFirst: "Pertama",
        sPrevious: "&laquo;",
        sNext: "&raquo;",
        sLast: "Terakhir",
      },
    },
  });

  $("#jadwaleksekutif").DataTable({
    order: [[0, "asc"]],
    paging: true,
    ordering: true,
    info: true,
    filter: true,
    pageLength: 10,
    retrieve: true,
    language: {
      sEmptyTable: "Tidak Ada Data",
      sProcessing: "Sedang memproses...",
      sLengthMenu: "tampil : _MENU_",
      sZeroRecords: "Tidak ditemukan data yang sesuai",
      sInfo: "_END_ dari total _TOTAL_ data",
      sInfoEmpty: "0 data",
      sInfoFiltered: "(disaring dari _MAX_ data)",
      sInfoPostFix: "",
      sSearch: "Cari : ",
      sUrl: "",
      oPaginate: {
        sFirst: "Pertama",
        sPrevious: "&laquo;",
        sNext: "&raquo;",
        sLast: "Terakhir",
      },
    },
  });

  $("#agenda").dataTable({
    retrieve: true,
    paging: true,
    ordering: true,
    info: false,
    filter: true,
    pageLength: 10,
    language: {
      sEmptyTable: "Tidak Ada Data",
      sProcessing: "Sedang memproses...",
      sLengthMenu: "tampil : _MENU_",
      sZeroRecords: "Tidak ditemukan data yang sesuai",
      sInfo: "_END_ dari total _TOTAL_ data",
      sInfoEmpty: "0 data",
      sInfoFiltered: "(disaring dari _MAX_ data)",
      sInfoPostFix: "",
      sSearch: "Cari agenda : ",
      sUrl: "",
      oPaginate: {
        sFirst: "Pertama",
        sPrevious: "&laquo;",
        sNext: "&raquo;",
        sLast: "Terakhir",
      },
    },
  });

  $("#olahJadwal").DataTable({
    // "paging": false,
    order: [[0, "asc"]],
    ordering: true,
    info: false,
    processing: true,
    retrieve: true,
    colReorder: {
      realtime: false,
    },
    // dom: 'Bfrtip',
    // buttons: [
    //     {
    //         extend: 'excelHtml5',
    //         title: '',
    //         exportOptions: {
    //             columns: [0, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
    //         }
    //     },
    // ],
    language: {
      sEmptyTable: "Tidak Ada Data",
      sProcessing: "Sedang memproses...",
      sLengthMenu: "tampil : _MENU_",
      sZeroRecords: "Tidak ditemukan data yang sesuai",
      sInfo: "_END_ dari total _TOTAL_ data",
      sInfoEmpty: "0 data",
      sInfoFiltered: "(disaring dari _MAX_ data)",
      sInfoPostFix: "",
      sSearch: "Cari jadwal : ",
      sUrl: "",
      oPaginate: {
        sFirst: "Pertama",
        sPrevious: "&laquo;",
        sNext: "&raquo;",
        sLast: "Terakhir",
      },
    },
  });

  $("#genPass").DataTable({
    paging: false,
    ordering: false,
    info: false,
    processing: true,
    retrieve: true,
    colReorder: {
      realtime: false,
    },
    dom: "Bfrtip",
    buttons: [
      {
        extend: "excelHtml5",
        title: "",
        exportOptions: {
          columns: [0, 1, 2, 3],
        },
      },
    ],
    language: {
      sEmptyTable: "Tidak Ada Data",
      sProcessing: "Sedang memproses...",
      sLengthMenu: "tampil : _MENU_",
      sZeroRecords: "Tidak ditemukan data yang sesuai",
      sInfo: "_END_ dari total _TOTAL_ data",
      sInfoEmpty: "0 data",
      sInfoFiltered: "(disaring dari _MAX_ data)",
      sInfoPostFix: "",
      sSearch: "Cari mahasiswa : ",
      sUrl: "",
      oPaginate: {
        sFirst: "Pertama",
        sPrevious: "&laquo;",
        sNext: "&raquo;",
        sLast: "Terakhir",
      },
    },
  });
  $(".buttons-excel").html(
    '<span><i class="fa fa-print"></i>&nbsp;&nbsp;export to excel</span>'
  );

  $("#cekKrsTable").DataTable({
    paging: false,
    ordering: false,
    info: false,
    processing: true,
    retrieve: true,
    colReorder: {
      realtime: false,
    },
    dom: "Bfrtip",
    // buttons: [
    //   {
    //     extend: "excelHtml5",
    //     title: "",
    //     exportOptions: {
    //       columns: [0, 1, 2, 3, 4],
    //     },
    //   },
    // ],
    language: {
      sEmptyTable: "Tidak Ada Data",
      sProcessing: "Sedang memproses...",
      sLengthMenu: "tampil : _MENU_",
      sZeroRecords: "Tidak ditemukan data yang sesuai",
      sInfo: "_END_ dari total _TOTAL_ data",
      sInfoEmpty: "0 data",
      sInfoFiltered: "(disaring dari _MAX_ data)",
      sInfoPostFix: "",
      sSearch: "Cari mahasiswa : ",
      sUrl: "",
      oPaginate: {
        sFirst: "Pertama",
        sPrevious: "&laquo;",
        sNext: "&raquo;",
        sLast: "Terakhir",
      },
    },
  });
  $(".buttons-excel").html(
    '<span><i class="fa fa-print"></i>&nbsp;&nbsp;export to excel</span>'
  );

  $("#MK").dataTable({
    retrieve: true,
    paging: false,
    ordering: true,
    info: false,
    filter: true,
    order: [[4, "asc"]],
    autoWidth: false,
    language: {
      sEmptyTable: "Tidak Ada Data",
      sProcessing: "Sedang memproses...",
      sLengthMenu: "tampil : _MENU_",
      sZeroRecords: "Tidak ditemukan data yang sesuai",
      sInfo: "_END_ dari total _TOTAL_ data",
      sInfoEmpty: "0 data",
      sInfoFiltered: "(disaring dari _MAX_ data)",
      sInfoPostFix: "",
      sSearch: "Cari mata kuliah : ",
      sUrl: "",
      oPaginate: {
        sFirst: "Pertama",
        sPrevious: "&laquo;",
        sNext: "&raquo;",
        sLast: "Terakhir",
      },
    },
  });

  $("#Jadwal").dataTable({
    retrieve: true,
    paging: false,
    ordering: false,
    info: false,
    filter: true,
    order: [[4, "asc"]],
    autoWidth: false,
    language: {
      sEmptyTable: "Tidak Ada Data",
      sProcessing: "Sedang memproses...",
      sLengthMenu: "tampil : _MENU_",
      sZeroRecords: "Tidak ditemukan data yang sesuai",
      sInfo: "_END_ dari total _TOTAL_ data",
      sInfoEmpty: "0 data",
      sInfoFiltered: "(disaring dari _MAX_ data)",
      sInfoPostFix: "",
      sSearch: "Cari jadwal kuliah : ",
      sUrl: "",
      oPaginate: {
        sFirst: "Pertama",
        sPrevious: "&laquo;",
        sNext: "&raquo;",
        sLast: "Terakhir",
      },
    },
  });


  $("#Ruangantabel").DataTable({
    order: [[0, "asc"]],
    paging: true,
    ordering: true,
    info: true,
    filter: true,
    pageLength: 25,
    retrieve: true,
    language: {
      sEmptyTable: "Tidak Ada Data",
      sProcessing: "Sedang memproses...",
      sLengthMenu: "tampil : _MENU_",
      sZeroRecords: "Tidak ditemukan data yang sesuai",
      sInfo: "_END_ dari total _TOTAL_ data",
      sInfoEmpty: "0 data",
      sInfoFiltered: "(disaring dari _MAX_ data)",
      sInfoPostFix: "",
      sSearch: "Cari : ",
      sUrl: "",
      oPaginate: {
        sFirst: "Pertama",
        sPrevious: "&laquo;",
        sNext: "&raquo;",
        sLast: "Terakhir",
      },
    },
  });

  $("#Ruanganjadwalreguler").DataTable({
    order: [[0, "asc"]],
    paging: true,
    ordering: true,
    info: true,
    filter: true,
    pageLength: 25,
    retrieve: true,
    language: {
      sEmptyTable: "Tidak Ada Data",
      sProcessing: "Sedang memproses...",
      sLengthMenu: "tampil : _MENU_",
      sZeroRecords: "Tidak ditemukan data yang sesuai",
      sInfo: "_END_ dari total _TOTAL_ data",
      sInfoEmpty: "0 data",
      sInfoFiltered: "(disaring dari _MAX_ data)",
      sInfoPostFix: "",
      sSearch: "Cari : ",
      sUrl: "",
      oPaginate: {
        sFirst: "Pertama",
        sPrevious: "&laquo;",
        sNext: "&raquo;",
        sLast: "Terakhir",
      },
    },
  });

  $("#Ruanganjadwaleksekutif").DataTable({
    order: [[0, "asc"]],
    paging: true,
    ordering: true,
    info: true,
    filter: true,
    pageLength: 25,
    retrieve: true,
    language: {
      sEmptyTable: "Tidak Ada Data",
      sProcessing: "Sedang memproses...",
      sLengthMenu: "tampil : _MENU_",
      sZeroRecords: "Tidak ditemukan data yang sesuai",
      sInfo: "_END_ dari total _TOTAL_ data",
      sInfoEmpty: "0 data",
      sInfoFiltered: "(disaring dari _MAX_ data)",
      sInfoPostFix: "",
      sSearch: "Cari : ",
      sUrl: "",
      oPaginate: {
        sFirst: "Pertama",
        sPrevious: "&laquo;",
        sNext: "&raquo;",
        sLast: "Terakhir",
      },
    },
  });


  return null;

}

export default ConfDtb;
